const hosts = {
    microservices: {
      co: 'https://services.grability.rappi.com/',
      mx: 'https://services.mxgrability.rappi.com/',
      ar: 'https://services.rappi.com.ar/',
      br: 'https://services.rappi.com.br/',
      cl: 'https://services.rappi.cl/',
      uy: 'https://services.rappi.com.uy/',
      cr: 'https://services.rappi.co.cr/',
      ec: 'https://services.rappi.com.ec/',
      pe: 'https://services.rappi.pe/'
    }
}

const dev_hosts = {
    microservices: {
      co: 'https://microservices.dev.rappi.com/'
    },
}
  
function getHeaders() {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
      'Content-Type':  'application/json',
      // 'AUTH_USER': '456'
      'AUTH_USER': '123454567'
    }
    return headers;
}

function getMicroservicesUrl() {
    const country = localStorage.getItem('country');
    const enviroment = process.env.REACT_APP_ENVIROMENT_MODE === 'production' ? hosts : dev_hosts;
    return enviroment.microservices[country];
}

function getGrabilityUrl() {
    const country = localStorage.getItem('country');
    return hosts.grability[country];
}

function getRappiWebUrl() {
    const country = localStorage.getItem('country');
    return hosts.rappi_web[country];
}

function getImageUrl() {
    const country = localStorage.getItem('country');
    return hosts.images[country];
}


export default { getHeaders, getMicroservicesUrl, getGrabilityUrl, getRappiWebUrl, getImageUrl }